/** Savings / sessions / tickets tiles on the member page. */
export function MembershipStats({ stats }) {
  if (!stats) return null;
  const tiles = [
    ["Saved so far", `$${Number(stats.lifetime_saved_usd).toFixed(2)}`, "membership-stat-saved"],
    ["Sessions booked", stats.sessions, "membership-stat-sessions"],
    ["Included used", stats.included_used, "membership-stat-included"],
    ["Priority tickets", stats.tickets, "membership-stat-tickets"],
  ];
  return (
    <div className="mt-4 grid grid-cols-2 sm:grid-cols-4 gap-2 text-sm" data-testid="membership-stats">
      {tiles.map(([label, value, tid]) => (
        <div key={tid} className="rounded-xl border border-slate-800 bg-slate-900/50 p-3" data-testid={tid}>
          <div className="dg-eyebrow">{label}</div>
          <div className="font-display font-extrabold text-xl text-[#FFD600] mt-0.5">{value}</div>
        </div>
      ))}
      {stats.member_since && (
        <div className="col-span-2 sm:col-span-4 text-xs text-slate-500" data-testid="membership-stat-since">
          {stats.rejoined ? "Welcome back — member since" : "Member since"} {new Date(stats.member_since).toLocaleDateString(undefined, { month: "long", day: "numeric", year: "numeric" })} — savings count member discounts and included sessions on every booking made with this email.
        </div>
      )}
    </div>
  );
}
